import React from 'react';
import { Button } from 'reactstrap';

export default (props) => {
  return (
    <Button color="danger">Danger!</Button>
  );
};



// WEBPACK FOOTER //
// ./docs/lib/examples/import-basic.js